export default "__VITE_ASSET__B7pJev2T__"